// Ubicación en el repo: src/components/Spinner.jsx
// Spinner reutilizable para el software interno (24-ago-2026, ronda
// estética a pedido de Nicolás) — hasta ahora casi toda la app mostraba
// "Cargando…" como texto plano mientras el auto-agendamiento público
// (/agendamiento-online) ya tenía un spinner real (`.pubsched-spinner` en
// index.css). Mismo lenguaje visual acá (círculo con borde animado,
// mismo criterio de colores), pero con sus propias clases `.app-spinner*`
// para no acoplar el software interno a CSS pensado para esa página
// pública — ver DECISIONS.md.
//
// `size="lg"` para pantallas completas (App.jsx/Layout.jsx/SetPassword.jsx/
// PatientDetail.jsx mientras cargan), tamaño por defecto para el resto
// (dentro de una celda de tabla, un panel, un modal). `inline` para usarlo
// dentro de elementos que ya son inline por su cuenta (ej. <td>).
export default function Spinner({ label = 'Cargando…', size = 'md', inline = false }) {
  const wrapClass = [
    'app-spinner-wrap',
    inline && 'app-spinner-wrap--inline',
    size === 'lg' && 'app-spinner-wrap--lg',
  ]
    .filter(Boolean)
    .join(' ');
  const spinnerClass = ['app-spinner', size === 'lg' && 'app-spinner--lg'].filter(Boolean).join(' ');

  return (
    <span className={wrapClass}>
      <span className={spinnerClass} aria-hidden="true" />
      {label && <span className="app-spinner-label">{label}</span>}
    </span>
  );
}
